import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import type { IFlexiRequest } from '../types/flexi';
import { fetchFlexiRequests, fetchAgentList } from '../hooks/queries';
import { useNotifState } from '../state/notifs';
import TableWithSearchCTA from '../components/TableWithSearchCTA';
import SideModal from '../components/common/SideModal';
import FlexiRequestDetails from '../components/FlexiRequestDetails';
import { useFlexiRequestsCol } from '../components/columns/useFlexiRequestsCol';
import { getFlexiStatusColor } from '../components/flexi-requests/utils';

const FlexiRequests = () => {
  const { setShowNotification } = useNotifState();

  const [selectedFlexiRequest, setSelectedFlexiRequest] =
    useState<IFlexiRequest>();

  useEffect(() => {
    setShowNotification(false);
  }, []);

  const {
    data: flexiRequestsData,
    isLoading: isLoadingFlexiRequests,
    isFetching: isFetchingFlexiRequests,
    refetch: refetchFlexiRequests,
    error,
  } = fetchFlexiRequests();

  const {
    data: agents,
    isLoading: isLoadingAgents,
    isFetching: isFetchingAgents,
  } = fetchAgentList();

  const columns = useFlexiRequestsCol({
    onView: (data) => setSelectedFlexiRequest(data),
    agents: agents?.agents ?? [],
  });

  const closeFlexiModal = () => setSelectedFlexiRequest(undefined);

  return (
    <div
      className="w-full flex flex-col"
      style={{ height: 'calc(100vh - 3rem)' }}
    >
      <TableWithSearchCTA
        columnDefs={columns}
        rowData={flexiRequestsData?.data?.requests ?? []}
        isLoading={isLoadingFlexiRequests || isLoadingAgents}
        isFetching={isFetchingFlexiRequests || isFetchingAgents}
        error={error as Error}
        refetch={refetchFlexiRequests}
        headerTitle="Flexi Shift Requests"
        enableRefresh
        storageKey="flexi_shift_requests_table"
      />
      <SideModal
        title={
          <h2 className="text-lg font-semibold flex items-center">
            Flexi Shift Request
            {selectedFlexiRequest?.status && (
              <span className="ml-2">
                <span
                  className={`inline-block px-2 py-1 text-xs rounded ${getFlexiStatusColor(selectedFlexiRequest.status, true)}`}
                >
                  {selectedFlexiRequest.status}
                </span>
              </span>
            )}
          </h2>
        }
        isOpen={!!selectedFlexiRequest}
        onClose={closeFlexiModal}
      >
        <FlexiRequestDetails
          key={selectedFlexiRequest?._id}
          flexiRequest={selectedFlexiRequest}
          onUpdate={() => {
            toast.success('Flexi request updated successfully!');
            closeFlexiModal();
          }}
          onUpdateError={() => toast.error('Error updating flexi request')}
        />
      </SideModal>
    </div>
  );
};

export default FlexiRequests;
